import { gql } from "@apollo/client"

export const PRINTER_FIELDS = gql`
  fragment PrinterFields on Printer {
    ... on BluetoothPrinter {
      id
      name
      type
      address
      settings {
        ...PrinterSettingsFields
      }
    }
    ... on BluetoothLowEnergyPrinter {
      id
      name
      type
      address
      settings {
        ...PrinterSettingsFields
      }
    }
    ... on NetworkPrinter {
      id
      name
      type
      address
      port
      settings {
        ...PrinterSettingsFields
      }
      location {
        id
        name
      }
    }
    ... on USBPrinter {
      id
      name
      type
      address
      deviceName @client
      vendorId
      productId
      serialNumber
      settings {
        ...PrinterSettingsFields
      }
    }
  }
  fragment PrinterSettingsFields on PrinterSettings {
    sizes {
      preset
      width
      height
    }
    dpi
  }
`
